<template>
  <div id="app" :class="AppClass">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
  import Dialog from './components/Popups/Dialog'
  import Toast from './components/Popups/Toast'
  import ShareDialog from './components/Popups/ShareDialog'
  // import RulerDialog from './components/Popups/RulerDialog'
  // import {PAGE_CREATE} from './constant/eventbus'
  import Vue from 'vue'
  import {mapState, mapActions} from 'vuex'
  import {
    ACT_P_ORDER,
    ACT_ORDER,
    ACT_E_ORDER,
    ACT_P_GO,
    ACT_GO,
    ACT_E_GO
    } from './constant/act_stat'
import { pageConfig } from './constant/products';
import { setShare } from './tools/mgtv/share';
  Vue.filter('currency' , function(value) {
          return '¥'+value.toFixed(2) ;
  });
  Vue.filter('currency2' , function(value) {
        return value.toFixed(2) +'元' ;
  });
  export default {
    name: 'App',
    components: {

    },
    created(){
      window.$router = this.$router;    
      // setTimeout(()=>{
      //   window.$bus.$emit(PAGE_CREATE);
      //   console.log("触发PAGE_CREATE")
      // },1000)  
      
      console.log("created")
      setTimeout(() => {
        if (window.Bulma) {
          window.Bulma.log('pv', {istc: "mem", ac: this.urlParams.source, uuid: this.userInfo.uuid, uvip: this.userInfo.uvip});
        }
      }, 1000);

    },
    beforeMount(){
    console.log("App beforeMount")
  },
    mounted(){
            
      console.log("App mounted")
      let T = this
      setTimeout(() => {
        setShare(window.shareData)
      }, 500);
      history.pushState(null,null,`/usercenter/niunai.html`)
      console.log("开始获取活动信息...")
      // this.getActInfo().then(()=>{
      //   console.log("活动信息已获取")
      //   console.log("开始获取ticket...")        
      //   //获取登录信息
      //   this.getTicket().then(()=>{     
      //     console.log("ticket已获取")
      //     console.log("开始获取用户信息...")
      //     this.getUserInfo().then(()=>{
      //       console.log("用户信息已获取")
      //       console.log("开始获取优惠券信息...")
      //       const ticket = T.ticket
      //       const productId = T.product.id
      //       this.getVoucher({ticket,productId}).then(()=>{

      //       }).catch(error=>{
      //           console.log(" getVoucher reject",error)
      //       })
      //     }).catch(error=>{
      //       console.log(" getUserInfo reject",error)
      //   })

      //   }).catch(error=>{
      //       console.log(" getTicket reject",error)
      //   })
      // }).catch(error=>{
      //       console.log(" getActInfo reject",error)
      //   })
      // this.getActInfo();
      // this.getUserInfo();
      this.getVoucher().then().catch(error=>{
        console.log(" getVoucher reject",error)
      })
      
    },
    computed: {
        ...mapState([
            'actInfo',
            'userInfo',
            'deviceInfo',
            'urlParams',
            'ticket',
            'voucher',
            'product'
        ]),
        AppClass(){
          let className= ""
          if(this.$store.getters.orderTime){
            document.title = pageConfig.order.title;
            className = "orderApp"
          }
          else if(this.$store.getters.goTime){
            document.title = pageConfig.go.title;
            className = "goApp"
          }
          return className
        }
    },
    methods: {
        ...mapActions([
            'getActInfo',
            'getTicket',
            'getUserInfo',
            'getVoucher'
        ]),
        reload(){
          this.isRouterAlive = false
          this.$nextTick(function(){
            this.isRouterAlive = true
          })
        }
    },
    provide(){
      return{
        reload:this.reload
      }
    },
    data(){
      return {
        isRouterAlive:true
        }
    },

  }
</script>
<style scoped lang="stylus">
  @import "share/mixins.styl"
  html{width:100%;}
  body{width:100%;}
  #app {
    width: 100%;
    margin: 0 auto;
    max-width: 7.68rem;
    min-height: 100vh;
    background-color white
    position relative
    overflow hidden
  }

  .nav
    height 1.14rem
    width 7.5rem
    position fixed
    border-bottom 1px solid #ebebeb
    background white
    overflow-y: hidden;
    overflow-x: auto;
    padding-left .32rem
    z-index 10
  .item-wrap
    height 100%
    position relative
    display flex
    -webkit-overflow-scrolling:touch
    white-space: nowrap;
    align-items center
  .nav-item
    position: relative;
    margin-right  .8rem;
    font-size: .3rem;
    display: inline-block;


  .current
    font-weight: 700;
    color: #d6ab56;
    &:after
      display inline-block
      position absolute
      hcenter()
      content: "";
      bottom: -0.12rem;
      width: 0.4rem;
      height: 0.06rem;
      background-color: #d6ab56;
  .van-button
    cursor pointer
</style>



// WEBPACK FOOTER //
// src/App.vue